import React, { Component } from 'react';
import { connect } from 'react-redux';
import FactsComponent from './FactsComponent';
import FeaturesComponent from './FeaturesComponent';
import DocumentsComponent from './DocumentsComponent';

class DetailsContainer extends Component {
    render () {

        const { property, tourId, isActive, propertyDetailsBtnVisibility } = this.props;
        if (!propertyDetailsBtnVisibility) {
            return null
        }
        return (
            <div id="details" className="details-container">
                <h2 className="section-header">Property Details</h2>
                <FactsComponent info={property.info} orderId={tourId} status={isActive}/>
                <FeaturesComponent propertyFeatures={property.features}/>
                {/* <DocumentsComponent documents= {property.documents} /> */}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        property: state.property,
        tourId: state.app.tourId,
        isActive: state.app.isActive,
        propertyDetailsBtnVisibility: state.app.buttonsVisibility.propertyDetailsBtnVisibility
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailsContainer)